var _path, _path2, _path3, _path4, _g, _path5, _path6, _path7, _g2, _g3, _path8, _path9, _path10, _path11, _g4, _ellipse, _ellipse2, _rect, _path12, _path13, _g5, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgThird(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 72,
    height: 137,
    viewBox: "0 0 72 137",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.3496 115.407C23.5046 111.902 31.013 107.824 35.184 106.271L41.6994 117.794L59.1142 121.635C56.9452 121.635 38.4783 130.231 30.4835 134.439V121.503C26.5107 118.647 22.3496 115.407 22.3496 115.407Z",
    fill: "#FFA02E"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M51.3722 112.672L59.1121 121.634L41.6973 117.793L51.3722 112.672Z",
    fill: "#DE7123"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M72.1196 0L92.7871 24.0069H51.4522L72.1196 0Z",
    fill: "url(#paint0_linear_1565_29650)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M72.1206 137L51.4532 112.993L92.7881 112.993L72.1206 137Z",
    fill: "url(#paint1_linear_1565_29650)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_f_1565_29650)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M71.5528 6.14648L73.9472 13.3727L81.2277 15.7492L73.9472 18.1258L71.5528 25.352L69.1584 18.1258L61.8779 15.7492L69.1584 13.3727L71.5528 6.14648Z",
    fill: "white",
    fillOpacity: 0.62
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.5528 6.3562L73.8846 13.3934L73.8951 13.4251L73.9268 13.4354L81.0151 15.7492L73.9268 18.0631L73.8951 18.0734L73.8846 18.1051L71.5528 25.1423L69.221 18.1051L69.2105 18.0734L69.1789 18.0631L62.0905 15.7492L69.1789 13.4354L69.2105 13.4251L69.221 13.3934L71.5528 6.3562Z",
    stroke: "#FFC886",
    strokeWidth: 0.131923
  }))), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M12.3513 34.2496L43.6318 28.4879L22.9643 64.0181L12.3513 34.2496Z",
    fill: "url(#paint2_linear_1565_29650)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M12.3508 102.749L22.9639 72.9808L43.6313 108.511L12.3508 102.749Z",
    fill: "url(#paint3_linear_1565_29650)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M125.326 67.8591C125.326 96.6669 101.797 120.024 72.7663 120.024C43.7362 120.024 20.2068 96.6669 20.2068 67.8591C20.2068 39.0513 43.7362 15.6938 72.7663 15.6938C101.797 15.6938 125.326 39.0513 125.326 67.8591Z",
    fill: "url(#paint4_linear_1565_29650)",
    stroke: "url(#paint5_linear_1565_29650)",
    strokeWidth: 0.659613
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_i_1565_29650)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 72.7666,
    cy: 67.8604,
    rx: 46.4395,
    ry: 46.0933,
    fill: "url(#paint6_linear_1565_29650)"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_ii_1565_29650)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 72.7669,
    cy: 67.86,
    rx: 38.6996,
    ry: 38.411,
    fill: "url(#paint7_linear_1565_29650)"
  }))), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter3_d_1565_29650)"
  }, _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M49.8374 61.1005C49.1723 59.3138 51.17 57.7124 52.7691 58.7502L84.1109 79.0901C85.7639 80.1628 85.0042 82.7289 83.0336 82.7289H59.2633C58.4366 82.7289 57.6971 82.2151 57.4087 81.4404L49.8374 61.1005Z",
    fill: "url(#paint8_linear_1565_29650)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M95.6849 61.0765C96.3569 59.2942 94.3695 57.6846 92.7657 58.7123L60.9727 79.0839C59.3085 80.1502 60.0638 82.7289 62.0403 82.7289H86.1529C86.9765 82.7289 87.714 82.2188 88.0045 81.4481L95.6849 61.0765Z",
    fill: "url(#paint9_linear_1565_29650)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M70.9914 53.7835C71.7151 52.305 73.8224 52.305 74.5461 53.7835L87.4502 80.1469C88.0936 81.4616 87.1365 82.9957 85.6728 82.9957H59.8647C58.401 82.9957 57.4439 81.4616 58.0874 80.1469L70.9914 53.7835Z",
    fill: "url(#paint10_linear_1565_29650)"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1565_29650",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 57,
    y: 52,
    width: 31,
    height: 31
  }, _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M70.9914 53.7835C71.7151 52.305 73.8224 52.305 74.5461 53.7835L87.4502 80.1469C88.0936 81.4616 87.1365 82.9957 85.6728 82.9957H59.8647C58.401 82.9957 57.4439 81.4616 58.0874 80.1469L70.9914 53.7835Z",
    fill: "url(#paint11_linear_1565_29650)"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1565_29650)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 16.8373,
    cy: 4.5694,
    rx: 16.8373,
    ry: 4.5694,
    transform: "matrix(0.204188 0.978932 -0.979534 0.201279 83.1963 54.2734)",
    fill: "#ECA26C"
  }))), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 72.7688,
    cy: 47.7492,
    rx: 2.95927,
    ry: 2.93721,
    fill: "url(#paint12_linear_1565_29650)"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 49.3851,
    cy: 56.2936,
    rx: 2.42122,
    ry: 2.40317,
    fill: "url(#paint13_linear_1565_29650)"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 57.7695,
    y: 85.313,
    width: 29.4328,
    height: 3.98364,
    rx: 1.99182,
    fill: "url(#paint14_linear_1565_29650)"
  }))), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M52.1248 34.5698L53.0826 37.4603L55.9948 38.4109L53.0826 39.3616L52.1248 42.252L51.1671 39.3616L48.2549 38.4109L51.1671 37.4603L52.1248 34.5698Z",
    fill: "white"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M40.5152 21.7671L42.75 28.5115L49.5451 30.7297L42.75 32.9478L40.5152 39.6922L38.2805 32.9478L31.4854 30.7297L38.2805 28.5115L40.5152 21.7671Z",
    fill: "white"
  })), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter5_d_1565_29650)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M31.3789 101.442L41.6988 117.794C69.4335 103.07 95.8782 113.953 103.618 117.794L113.938 101.442C110.987 98.0582 98.6203 91.2164 72.7614 90.9156C46.9025 90.6149 34.3985 97.8076 31.3789 101.442Z",
    fill: "url(#paint15_linear_1565_29650)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_1565_29650",
    x: 58.5799,
    y: 2.84842,
    width: 25.9457,
    height: 25.8017,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.64903,
    result: "effect1_foregroundBlur_1565_29650"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_i_1565_29650",
    x: 26.3271,
    y: 20.4479,
    width: 92.8789,
    height: 93.5057,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: -1.31923
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.31923
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0.172667 0 0 0 0 0.616667 0 0 0 0.15 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_1565_29650"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_ii_1565_29650",
    x: 34.0674,
    y: 28.1297,
    width: 77.3994,
    height: 79.4605,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1.31923
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3.29807
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.4875 0 0 0 0 0.1755 0 0 0 0 0 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_1565_29650"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: -1.31923
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3.29807
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 0.716167 0 0 0 0 0.454167 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_innerShadow_1565_29650",
    result: "effect2_innerShadow_1565_29650"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter3_d_1565_29650",
    x: 44.3254,
    y: 43.4928,
    width: 56.7652,
    height: 49.7615,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1.31923
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.31923
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.6 0 0 0 0 0.361709 0 0 0 0 0.19 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1565_29650"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1565_29650",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter5_d_1565_29650",
    x: 18.1866,
    y: 84.3104,
    width: 108.943,
    height: 53.2722,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 6.59613
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 6.59613
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.3 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1565_29650"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1565_29650",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1565_29650",
    x1: 63.5283,
    y1: 9.60276,
    x2: 80.7109,
    y2: 9.60276,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.488759,
    stopColor: "#FFC786"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.488859,
    stopColor: "#D1E5EE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.488959,
    stopColor: "#D18E5C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1565_29650",
    x1: 80.7119,
    y1: 127.397,
    x2: 63.5293,
    y2: 127.397,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.488759,
    stopColor: "#FFC786"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.488859,
    stopColor: "#D1E5EE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.488959,
    stopColor: "#D18E5C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_1565_29650",
    x1: 16.4344,
    y1: 46.4358,
    x2: 24.9296,
    y2: 31.6111,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.488759,
    stopColor: "#FFC786"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.488859,
    stopColor: "#D1E5EE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.488959,
    stopColor: "#D18E5C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_1565_29650",
    x1: 25.0252,
    y1: 105.333,
    x2: 16.53,
    y2: 90.5081,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.488759,
    stopColor: "#FFC786"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.488859,
    stopColor: "#D1E5EE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.488959,
    stopColor: "#D18E5C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_1565_29650",
    x1: 38.8629,
    y1: 28.8243,
    x2: 108.797,
    y2: 107.414,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFC887"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.520833,
    stopColor: "#FFE7CB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B45612"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_1565_29650",
    x1: 72.7663,
    y1: 15.364,
    x2: 72.7663,
    y2: 120.354,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_1565_29650",
    x1: 43.097,
    y1: 32.6502,
    x2: 101.911,
    y2: 104.143,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D28E5D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFC887"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_1565_29650",
    x1: 47.1569,
    y1: 36.2274,
    x2: 78.633,
    y2: 106.448,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFCD92"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.484375,
    stopColor: "#D88335"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9C5A2A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_1565_29650",
    x1: 50.2953,
    y1: 63.2364,
    x2: 65.9207,
    y2: 74.6857,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFDBB0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D4905F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_1565_29650",
    x1: 93.6095,
    y1: 59.9295,
    x2: 84.1986,
    y2: 76.9964,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFDBAF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D28E5D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_1565_29650",
    x1: 64.5448,
    y1: 67.0591,
    x2: 81.2277,
    y2: 67.0591,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.49728,
    stopColor: "#FFC886"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49738,
    stopColor: "#D28E5D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_1565_29650",
    x1: 64.5448,
    y1: 67.0591,
    x2: 81.2277,
    y2: 67.0591,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.416667,
    stopColor: "#B1B0D8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49738,
    stopColor: "#FFCC1D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_1565_29650",
    x1: 72.7688,
    y1: 44.812,
    x2: 72.7688,
    y2: 50.6864,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE5C7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D28E5D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_1565_29650",
    x1: 49.3851,
    y1: 53.8904,
    x2: 49.3851,
    y2: 58.6967,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE5C7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D28E5D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_1565_29650",
    x1: 58.104,
    y1: 87.3048,
    x2: 87.5368,
    y2: 87.3048,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFC886"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D28E5D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear_1565_29650",
    x1: 35.7963,
    y1: 106.451,
    x2: 110.128,
    y2: 105.623,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFA02E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C85A00"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgThird);
export default __webpack_public_path__ + "static/media/third.401da15fa949cffdd50443fd085592cd.svg";
export { ForwardRef as ReactComponent };